export default "__VITE_ASSET__Bu3Iy0k9__"